import { HttpClient, HttpParams } from "@angular/common/http";
import * as objectToFormData from "object-to-formdata";
import { map } from "rxjs/operators";

export class DataService {
  /**
   * #param url
   * #param BaseUrl
   * #param http
   * #param origin
   */
  constructor(
    private url,
    private BaseUrl,
    private http: HttpClient,
    private origin: string
  ) {}

  //Declerations
  BaseURL = this.BaseUrl;
  export(CustomUrl?, pagination?, filteration?) {
    return this.http.get<any>(this.BaseURL + this.url + "/export", {
      responseType: "blob" as "json",
    });
  }
  GetWithFilter(CustomUrl, filteration) {
    return this.http.get<any>(
      this.BaseURL +
        this.url +
        (CustomUrl ? "\\" + CustomUrl : "") +
        (filteration ? this.handleParamsToQueryStrings(filteration) : ""),
      {
        observe: "response",
      }
    );
  }
  Get(CustomUrl?, pagination?, filteration?) {
    let params: HttpParams;
    if (filteration) {
      params = new HttpParams();
      params = params.append("filter", this.serializeObject(filteration));
    }
    return this.http.get<any>(
      this.BaseURL +
        this.url +
        (CustomUrl ? "\\" + CustomUrl : "") +
        (pagination ? "?" + this.serializeObject(pagination) : ""),
      {
        observe: "response",
        params: filteration ? params : null,
      }
    );
  }

  GetWithPagination(pagination) {
    return this.http.get<any>(
      this.BaseURL + this.url + "?" + this.serializeObject(pagination),
      {
        observe: "response",
      }
    );
  }

  GetById(id, pagination?) {
    return this.http.get<any>(
      this.BaseURL +
        this.url +
        "/" +
        id +
        (pagination ? "?" + this.serializeObject(pagination) : ""),
      {
        observe: "response",
      }
    );
  }
  GetPrice(resource, CustomUrl?, asFormData = true) {
    if (resource) {
      Object.entries(resource).forEach(([key, value]) => {
        (!Array.isArray(value) && (value === undefined || value === null)) ||
        (Array.isArray(value) && value.length === 0)
          ? delete resource[key]
          : null;
      });
    }
    return this.http.get<any>(
      this.BaseURL +
        this.url +
        (CustomUrl ? "\\" + CustomUrl : "") +
        `#${this.origin} Created Successfully` +
        asFormData
        ? objectToFormData(resource, { indices: true })
        : resource,
      {
        observe: "response",
      }
    );
  }
  Create(resource, CustomUrl?, asFormData = true) {
    if (resource) {
      Object.entries(resource).forEach(([key, value]) => {
        (!Array.isArray(value) && (value === undefined || value === null)) ||
        (Array.isArray(value) && value.length === 0)
          ? delete resource[key]
          : null;
      });
    }
    return this.http.post<any>(
      this.BaseURL +
        this.url +
        (CustomUrl ? "\\" + CustomUrl : "") +
        `#${this.origin} Created Successfully`,
      asFormData ? objectToFormData(resource, { indices: true }) : resource,
      {
        observe: "response",
      }
    );
  }
  ReadNotification(CustomUrl) {
    return this.http.post<any>(this.BaseURL + this.url + "/" + CustomUrl, {});
  }
  import(resource, CustomUrl?, asFormData = true) {
    let headers = {
      "Content-Type": "multipart/form-data",
    };

    return this.http.post<any>(
      this.BaseURL + this.url + (CustomUrl ? "\\" + CustomUrl : ""),
      resource
    );
  }
  addPoints(resource) {}
  UpdateOrCreate(resource, CustomUrl?, asFormData = true) {
    // if(resource){
    //   Object.entries(resource).forEach(([key,value])=>{
    //     (!Array.isArray(value) && (value===undefined || value === null)) || (Array.isArray(value) && value.length ===0 )
    //      ? delete resource[key]
    //      : null
    //   })
    // }
    return this.http.post<any>(
      this.BaseURL + this.url + (CustomUrl ? "\\" + CustomUrl : ""),
      {
        id: resource.id,
        name: resource.name,
        claims: resource.claims,
      }
    );
  }
  Upload(resource, CustomUrl?) {
    return this.http.post<any>(
      this.BaseURL +
        this.url +
        (CustomUrl ? "\\" + CustomUrl : "") +
        `#${this.origin} Created Successfully`,
      objectToFormData(resource, { indices: true }),
      {
        observe: "response",
      }
    );
  }
  Update(resource, CustomUrl?, asFormData = true) {
    if (resource) {
      Object.entries(resource).forEach(([key, value]) => {
        (!Array.isArray(value) && !value) ||
        (Array.isArray(value) && value.length === 0)
          ? delete resource[key]
          : null;
      });
    }
    return this.http.put<any>(
      this.BaseURL + this.url + (CustomUrl ? "\\" + CustomUrl : ""),
      asFormData ? objectToFormData(resource, { indices: true }) : resource,
      {
        observe: "response",
      }
    );
  }

  delete(id, CustomUrl?, pagination?) {
    return this.http.delete<any>(
      this.BaseURL + this.url + (CustomUrl ? "\\" + CustomUrl : "") + "/" + id,
      {
        observe: "response",
      }
    );
  }
  deleteWithParam(CustomUrl?, pagination?) {
    return this.http.delete<any>(
      this.BaseURL +
        this.url +
        (CustomUrl ? "\\" + CustomUrl : "") +
        (pagination ? "?" + this.serializeObject(pagination) : ""),
      {
        observe: "response",
      }
    );
  }

  deleteWithObject(resource, CustomUrl?, asFormData = true) {
    return this.http.delete<any>(
      this.BaseURL + this.url + (CustomUrl ? "\\" + CustomUrl : ""),
      {
        body: asFormData
          ? objectToFormData(resource, { indices: true })
          : resource,
      }
    );
  }
  UpdateWithParam(resource, CustomUrl?) {
    return this.http.put(
      this.BaseURL +
        this.url +
        "/" +
        (CustomUrl ? CustomUrl : "") +
        resource +
        `#${this.origin} Update Successfully`,
      {
        observe: "response",
      }
    );
  }
  UpdateByParam(resource, CustomUrl?) {
    return this.http.put(
      this.BaseURL +
        this.url +
        "/" +
        (CustomUrl ? CustomUrl : "") +
        "?" +
        this.serializeObject(resource) +
        `#${this.origin} Update Successfully`,
      {
        observe: "response",
      }
    );
  }

  Login(resource, asFormData = true) {
    this.BaseURL + this.url;
    return this.http.post<any>(
      this.BaseURL + this.url,
      asFormData ? objectToFormData(resource, { indices: true }) : resource,
      {
        observe: "response",
      }
    );
  }

  serializeObject(object) {
    let obj = {};
    Object.entries(object).forEach(([key, value]) => {
      !Array.isArray(value) && (value !== undefined || value !== null)
        ? (obj[key] = value)
        : null;
      if (Array.isArray(value) && value.length > 0) {
        for (let index = 0; index < value.length; index++) {
          const element = value[index];
          obj[`${key}[${index}]`] = element;
        }
      }
    });

    return Object.entries(obj)
      .map(([key, val]) => {
        return `${key}=${val}`;
      })
      .join("&");
  }
  handleParamsToQueryStrings(object) {
    let queryStringsUrl = "?";
    Object.entries(object).forEach(([key, value]) => {
      if (
        key?.toString().includes("BrandIds") ||
        key?.toString().includes("VendorIds") ||
        key?.toString().includes("CategoryIds")
      ) {
        (value as any).forEach((element) => {
          queryStringsUrl += `${key}=${element}&`;
        });
      } else if (
        (!Array.isArray(value) && (value !== undefined || value !== null)) ||
        (Array.isArray(value) && value.length > 0)
      ) {
        queryStringsUrl += `${key}=${value}&`;
      }
    });

    return queryStringsUrl;
  }

  downloadFile(link: any) {
    var downloadURL = this.BaseURL + this.url + link;

    // link.click();
    window.open(downloadURL, "_blank");
  }
}
